import mark from "../../../assets/icon/bonus/mark.svg";
import markActive from "../../../assets/icon/bonus/markActive.svg";

const caseAssignmentPreferenceStyles = {
  card: { marginTop: "1.5rem", padding: "1.75rem" },
  heading: { justifyContent: "space-between", alignItems: "center" },
  subheading: { marginTop: "0.375rem", color: "text.secondary" },
  badge: {
    color: "primary.main",
    backgroundColor: "background.selected",
    height: "2.25rem",
    padding: "0 0.5rem",
    "& .MuiChip-icon": { marginLeft: "0.375rem" },
  },
  // Die Slider-Enden liegen auf den Mitten der äußeren Kacheln: drei Grid-Spalten mit zwei 1rem-Lücken,
  // eine halbe Spaltenbreite ist also (100% - 2rem) / 6.
  sliderContainer: { margin: "1rem calc((100% - 2rem) / 6) 0" },
  slider: {
    padding: "1.5rem 0 0.5rem",
    // Der nicht gewählte Teil der Schiene soll grau sein statt im MUI-Standard halbtransparent in der Primärfarbe.
    "& .MuiSlider-rail": { backgroundColor: "grey.300", opacity: 1 },
    "& .MuiSlider-mark": { backgroundImage: `url("${mark}")`, backgroundColor: "transparent" },
    "& .MuiSlider-markActive": { backgroundImage: `url("${markActive}")` },
  },
  sliderPlaceholder: { padding: "1.5rem 0 0.5rem" },
  option: {
    width: "100%",
    minHeight: "6.5rem",
    padding: "0.75rem 1rem",
    border: "0.0625rem solid",
    borderColor: "divider",
    borderRadius: "0.5rem",
    transition: "border-color 150ms, background-color 150ms",
  },
  selectedOption: {
    borderColor: "primary.main",
    backgroundColor: "background.selected",
    color: "primary.main",
  },
  optionLabel: { lineHeight: "1.375rem" },
  optionDescription: { color: "text.secondary", lineHeight: "1.125rem" },
};

export default caseAssignmentPreferenceStyles;
